module.exports = "/components/components/otherPremiumFeaturesComponent-efc246.html";